module.exports = __webpack_public_path__ + "static/img/name_logos_new.4546c92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/name_logos_new.png
// module id = yd1C
// module chunks = 1